import {
    BONUS_TYPE,
    ENABLE_DISABLE_TYPE,
    INDUSTRY_TYPE,
    JOB_FUNCTION_OPTIONS,
    SALARY_BAND_TYPE,
    WORK_MODEL_TYPES,
    YES_NO_TYPE,
    LEAVE_TYPE, JOB_TYPE_MODEL_TYPES, JOB_CATEGORY_MODEL_TYPE
} from "./optionEnums";

export const WORK_MODEL = [
    {
        value: WORK_MODEL_TYPES.ON_SITE.value,
        label: WORK_MODEL_TYPES.ON_SITE.label,
    },
    {
        value: WORK_MODEL_TYPES.REMOTE.value,
        label: WORK_MODEL_TYPES.REMOTE.label,
    },
    {
        value: WORK_MODEL_TYPES.HYBRID.value,
        label: WORK_MODEL_TYPES.HYBRID.label,
    }
];

export const JOB_TYPE_MODEL = [
    {
        value: JOB_TYPE_MODEL_TYPES.PERMANENT.value,
        label: JOB_TYPE_MODEL_TYPES.PERMANENT.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.PART_TIME.value,
        label: JOB_TYPE_MODEL_TYPES.PART_TIME.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.CONTRACT.value,
        label: JOB_TYPE_MODEL_TYPES.CONTRACT.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.FREELANCE.value,
        label: JOB_TYPE_MODEL_TYPES.FREELANCE.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.INTERNSHIP.value,
        label: JOB_TYPE_MODEL_TYPES.INTERNSHIP.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.TEMPORARY.value,
        label: JOB_TYPE_MODEL_TYPES.TEMPORARY.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.CONSULTING.value,
        label: JOB_TYPE_MODEL_TYPES.CONSULTING.label,
    },
    {
        value: JOB_TYPE_MODEL_TYPES.COMMISSION_BASED.value,
        label: JOB_TYPE_MODEL_TYPES.COMMISSION_BASED.label,
    },
];

export const JOB_CATEGORY_MODEL = [
    {
        value: JOB_CATEGORY_MODEL_TYPE.SOFTWARE_DEVELOPMENT.value,
        label: JOB_CATEGORY_MODEL_TYPE.SOFTWARE_DEVELOPMENT.label,
        description:  JOB_CATEGORY_MODEL_TYPE.SOFTWARE_DEVELOPMENT.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.WEB_DEVELOPMENT.value,
        label: JOB_CATEGORY_MODEL_TYPE.WEB_DEVELOPMENT.label,
        description:  JOB_CATEGORY_MODEL_TYPE.WEB_DEVELOPMENT.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.DATA_SCIENCE.value,
        label: JOB_CATEGORY_MODEL_TYPE.DATA_SCIENCE.label,
        description:  JOB_CATEGORY_MODEL_TYPE.DATA_SCIENCE.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.IT_SUPPORT.value,
        label: JOB_CATEGORY_MODEL_TYPE.IT_SUPPORT.label,
        description:  JOB_CATEGORY_MODEL_TYPE.IT_SUPPORT.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.NETWORK_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.NETWORK_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.NETWORK_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.CYBERSECURITY.value,
        label: JOB_CATEGORY_MODEL_TYPE.CYBERSECURITY.label,
        description:  JOB_CATEGORY_MODEL_TYPE.CYBERSECURITY.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.MECHANICAL_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.MECHANICAL_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.MECHANICAL_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.ELECTRICAL_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.ELECTRICAL_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.ELECTRICAL_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.CIVIL_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.CIVIL_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.CIVIL_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.CHEMICAL_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.CHEMICAL_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.CHEMICAL_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.AEROSPACE_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.AEROSPACE_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.AEROSPACE_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.BIOMEDICAL_ENGINEERING.value,
        label: JOB_CATEGORY_MODEL_TYPE.BIOMEDICAL_ENGINEERING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.BIOMEDICAL_ENGINEERING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.NURSING.value,
        label: JOB_CATEGORY_MODEL_TYPE.NURSING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.NURSING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.PHYSICIAN.value,
        label: JOB_CATEGORY_MODEL_TYPE.PHYSICIAN.label,
        description:  JOB_CATEGORY_MODEL_TYPE.PHYSICIAN.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.ALLIED_HEALTH.value,
        label: JOB_CATEGORY_MODEL_TYPE.ALLIED_HEALTH.label,
        description:  JOB_CATEGORY_MODEL_TYPE.ALLIED_HEALTH.description

    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.PHARMACY.value,
        label: JOB_CATEGORY_MODEL_TYPE.PHARMACY.label,
        description:  JOB_CATEGORY_MODEL_TYPE.PHARMACY.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.MEDICAL_RESEARCH.value,
        label: JOB_CATEGORY_MODEL_TYPE.MEDICAL_RESEARCH.label,
        description:  JOB_CATEGORY_MODEL_TYPE.MEDICAL_RESEARCH.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.HEALTHCARE_ADMINISTRATION.value,
        label: JOB_CATEGORY_MODEL_TYPE.HEALTHCARE_ADMINISTRATION.label,
        description:  JOB_CATEGORY_MODEL_TYPE.HEALTHCARE_ADMINISTRATION.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.ACCOUNTING.value,
        label: JOB_CATEGORY_MODEL_TYPE.ACCOUNTING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.ACCOUNTING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.FINANCE.value,
        label: JOB_CATEGORY_MODEL_TYPE.FINANCE.label,
        description:  JOB_CATEGORY_MODEL_TYPE.FINANCE.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.INVESTMENT_BANKING.value,
        label: JOB_CATEGORY_MODEL_TYPE.INVESTMENT_BANKING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.INVESTMENT_BANKING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.FINANCIAL_ANALYSIS.value,
        label: JOB_CATEGORY_MODEL_TYPE.FINANCIAL_ANALYSIS.label,
        description:  JOB_CATEGORY_MODEL_TYPE.FINANCIAL_ANALYSIS.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.AUDITING.value,
        label: JOB_CATEGORY_MODEL_TYPE.AUDITING.label,
        description:  JOB_CATEGORY_MODEL_TYPE.AUDITING.description
    },
    {
        value: JOB_CATEGORY_MODEL_TYPE.TAXATION.value,
        label: JOB_CATEGORY_MODEL_TYPE.TAXATION.label,
        description:  JOB_CATEGORY_MODEL_TYPE.TAXATION.description
    }
]

export const YES_NO_MODEL = [
    {
        value: true,
        label: YES_NO_TYPE.YES.label,
    },
    {
        value: false,
        label: YES_NO_TYPE.NO.label,
    }
];

export const ENABLED_DISABLED_MODEL = [
    {
        value: ENABLE_DISABLE_TYPE.ENABLED.value,
        label: ENABLE_DISABLE_TYPE.ENABLED.label,
    },
    {
        value: ENABLE_DISABLE_TYPE.DISABLED.value,
        label: ENABLE_DISABLE_TYPE.DISABLED.label,
    }
];

export const INDUSTRY_MODEL = [
    {
        value: INDUSTRY_TYPE.AGRICULTURE_FORESTRY.value,
        label: INDUSTRY_TYPE.AGRICULTURE_FORESTRY.label,
    },
    {
        value: INDUSTRY_TYPE.MINING.value,
        label: INDUSTRY_TYPE.MINING.label,
    },
    {
        value: INDUSTRY_TYPE.MANUFACTURING.value,
        label: INDUSTRY_TYPE.MANUFACTURING.label,
    },
    {
        value: INDUSTRY_TYPE.CONSTRUCTION.value,
        label: INDUSTRY_TYPE.CONSTRUCTION.label,
    },
    {
        value: INDUSTRY_TYPE.RETAIL_WHOLESALE.value,
        label: INDUSTRY_TYPE.RETAIL_WHOLESALE.label,
    },
    {
        value: INDUSTRY_TYPE.TRANSPORTATION_LOGISTICS.value,
        label: INDUSTRY_TYPE.TRANSPORTATION_LOGISTICS.label,
    },
    {
        value: INDUSTRY_TYPE.FINANCE_INSURANCE.value,
        label: INDUSTRY_TYPE.FINANCE_INSURANCE.label,
    },
    {
        value: INDUSTRY_TYPE.REAL_ESTATE.value,
        label: INDUSTRY_TYPE.REAL_ESTATE.label,
    },
    {
        value: INDUSTRY_TYPE.INFORMATION_TECHNOLOGY.value,
        label: INDUSTRY_TYPE.INFORMATION_TECHNOLOGY.label,
    },
    {
        value: INDUSTRY_TYPE.HEALTHCARE.value,
        label: INDUSTRY_TYPE.HEALTHCARE.label,
    },
    {
        value: INDUSTRY_TYPE.EDUCATION.value,
        label: INDUSTRY_TYPE.EDUCATION.label,
    },
    {
        value: INDUSTRY_TYPE.TOURISM_HOSPITALITY.value,
        label: INDUSTRY_TYPE.TOURISM_HOSPITALITY.label,
    },
    {
        value: INDUSTRY_TYPE.MEDIA_COMMUNICATIONS.value,
        label: INDUSTRY_TYPE.MEDIA_COMMUNICATIONS.label,
    },
    {
        value: INDUSTRY_TYPE.LEGAL_SERVICES.value,
        label: INDUSTRY_TYPE.LEGAL_SERVICES.label,
    },
    {
        value: INDUSTRY_TYPE.PUBLIC_SECTOR.value,
        label: INDUSTRY_TYPE.PUBLIC_SECTOR.label,
    },
    {
        value: INDUSTRY_TYPE.PROFESSIONAL_SERVICES.value,
        label: INDUSTRY_TYPE.PROFESSIONAL_SERVICES.label,
    },
];

export const JOB_FUNCTION = [
    {
        value: JOB_FUNCTION_OPTIONS.ACCOUNTING_FINANCE.value,
        label: JOB_FUNCTION_OPTIONS.ACCOUNTING_FINANCE.label,
    },
    {
        value: JOB_FUNCTION_OPTIONS.ADMINISTRATION.value,
        label: JOB_FUNCTION_OPTIONS.ADMINISTRATION.label,
    },
    {
        value: JOB_FUNCTION_OPTIONS.CUSTOMER_SERVICE.value,
        label: JOB_FUNCTION_OPTIONS.CUSTOMER_SERVICE.label,
    },
    {
        value: JOB_FUNCTION_OPTIONS.LEARNING_DEVELOPMENT.value,
        label: JOB_FUNCTION_OPTIONS.LEARNING_DEVELOPMENT.label,
    },
    {
        value: JOB_FUNCTION_OPTIONS.ENGINEERING.value,
        label: JOB_FUNCTION_OPTIONS.ENGINEERING.label,
    },
    {
        value: JOB_FUNCTION_OPTIONS.HUMAN_RESOURCES.value,
        label: JOB_FUNCTION_OPTIONS.HUMAN_RESOURCES.label,
    }
];


export const SALARY_BAND_MODEL = [
    {
        value: SALARY_BAND_TYPE.BAND_ONE.value,
        label: SALARY_BAND_TYPE.BAND_ONE.label,
    },
    {
        value: SALARY_BAND_TYPE.BAND_TWO.value,
        label: SALARY_BAND_TYPE.BAND_TWO.label,
    },
    {
        value: SALARY_BAND_TYPE.BAND_THREE.value,
        label: SALARY_BAND_TYPE.BAND_THREE.label,
    },
    {
        value: SALARY_BAND_TYPE.BAND_FOUR.value,
        label: SALARY_BAND_TYPE.BAND_FOUR.label,
    },
    {
        value: SALARY_BAND_TYPE.BAND_FIVE.value,
        label: SALARY_BAND_TYPE.BAND_FIVE.label,
    },
    {
        value: SALARY_BAND_TYPE.BAND_SIX.value,
        label: SALARY_BAND_TYPE.BAND_SIX.label,
    }
];

export const BONUS_MODEL = [
    {
        value: BONUS_TYPE.PERFORMANCE.value,
        label: BONUS_TYPE.PERFORMANCE.label,
    },
    {
        value: BONUS_TYPE.COMMISSION.value,
        label: BONUS_TYPE.COMMISSION.label,
    },
    {
        value: BONUS_TYPE.PROFIT_SHARE.value,
        label: BONUS_TYPE.PROFIT_SHARE.label,
    },
    {
        value: BONUS_TYPE.ADHOC.value,
        label: BONUS_TYPE.ADHOC.label,
    },
    {
        value: BONUS_TYPE.NONE.value,
        label: BONUS_TYPE.NONE.label,
    },
    {
        value: BONUS_TYPE.OTHER.value,
        label: BONUS_TYPE.OTHER.label,
    }
];

export const LEAVE_MODEL = [
    {
        value: LEAVE_TYPE.OPTION_ONE.value,
        label: LEAVE_TYPE.OPTION_ONE.label,
    },
    {
        value: LEAVE_TYPE.OPTION_TWO.value,
        label: LEAVE_TYPE.OPTION_TWO.label,
    }
];